import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { animated } from "react-spring";
import PrimaryButton from "../Button/Primary";
import SecondaryButton from "../Button/Secondary";
import IconClose from "../../Icon/Close";

const Container = styled(animated.div)`
  width: 768px;
  height: 272px;
  border-top: 8px solid var(--solera);
  max-height: 720px;
  box-shadow: 0 0 48px 0 rgba(109, 120, 129, 0.16);
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  height: auto;
  background: var(--white);

  .modal-header,
  .modal-footer {
    flex: 0;
    padding: 32px;
  }

  .modal-header {
    display: flex;
  }
  .modal-title {
    flex: 1;
    font-size: 20px;
    font-weight: 500;
  }
  .modal-content {
    flex: 1;
    padding: 0 32px;
    font-size: 14px;
    line-height: 20px;
    max-height: 506px;
    overflow-y: scroll;
  }
  .modal-footer {
    display: flex;
    flex-direction: row-reverse;
  }
  .modal-button {
    font-size: 12px;
    font-weight: 500;
    letter-spacing: 1.5px;
    line-height: 12px;
    margin: 0 16px 0 0;
  }
  .modal-button:first-child {
    margin: 0;
  }
`;

const UIModal = ({
  title,
  content,
  onClose,
  onAccept,
  onCancel,
  acceptButton,
  cancelButton,
  buttons,
  style,
  className
}) => {
  return (
    <Container style={style} className={className}>
      <div className="modal-header">
        <div className="modal-title">{title}</div>
        <IconClose title="Close" onClick={onClose} />
      </div>

      <div className="modal-content" dangerouslySetInnerHTML={{ __html: content }}></div>

      <div className="modal-footer">
        {acceptButton ? (
          <PrimaryButton className="modal-button" onClick={onAccept}>
            Accept
          </PrimaryButton>
        ) : null}

        {cancelButton ? (
          <SecondaryButton className="modal-button" onClick={onCancel}>
            Cancel
          </SecondaryButton>
        ) : null}

        {buttons}
      </div>
    </Container>
  );
};

UIModal.propTypes = {
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
  content: PropTypes.oneOfType([PropTypes.string, PropTypes.element])
    .isRequired,
  onClose: PropTypes.func,
  onAccept: PropTypes.func,
  onCancel: PropTypes.func,
  acceptButton: PropTypes.bool,
  cancelButton: PropTypes.bool,
  buttons: PropTypes.element
};

export default UIModal;
